<template>
  <ul class="c-list--checkup">
    <li class="c-list--checkup__item">
      <span class="c-list--checkup__label judgement">判定</span>
      <div class="c-list--checkup__content">
        <p v-if="!hasError">
          スマホサイトでのあなたのWebページの読み込み時間は{{
            detail.time
          }}秒で、平均読み込み速度{{
            detail.pageLoadSpeedStandard || 5
          }}秒以内です。
        </p>
        <p v-else>
          スマホサイトでのあなたのWebページの読み込み時間は{{
            detail.time
          }}秒で、平均読み込み速度{{
            detail.pageLoadSpeedStandard || 5
          }}秒以上です。
        </p>
      </div>
    </li>
    <li v-if="detail.time || detail.time === 0" class="c-list--checkup__item">
      <span class="c-list--checkup__label detail">内容</span>
      <div class="c-list--checkup__content">
        <p>スマホサイトでの読み込み速度: {{ detail.time }}秒</p>
      </div>
    </li>
    <li v-if="hasError" class="c-list--checkup__item">
      <span class="c-list--checkup__label hint">ヒント</span>
      <div class="c-list--checkup__content">
        <p>
          Webページの速度改善のために、スピード最適化のNG項目のヒントを試してみてください。
        </p>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      required: true
    },
    hasError: {
      type: Boolean,
      required: true
    }
  }
};
</script>
